import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/car.png'


const _withScopeId = n => (_pushScopeId("data-v-166018fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "move_car" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted } from 'vue'
import MoveDiv from '@/components/MoveDiv/index.vue'
import useRouter_Route from '@/hooks/useRouter_Route'
import useCart from '@/hooks/useCart'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { toNextRoute } = useRouter_Route()

const toCart = () => {
  toNextRoute('/cart')
}
const { cartCount, addToCart, getCartCount, changeNumer } = useCart()

onMounted(() => {
  getCartCount()
})

return (_ctx: any,_cache: any) => {
  const _component_van_badge = _resolveComponent("van-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MoveDiv, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_badge, {
          class: "",
          content: _unref(cartCount)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "cart_icon",
              onClick: toCart
            }, _hoisted_3)
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _: 1
    })
  ]))
}
}

})